<template>
  <div class="content-games-tweets">
    <Tweet v-for="(tweet, index) in tweets" :key="index" :infos="tweet" :number="index + 1" />
  </div>
</template>

<script>
import Tweet from "./Tweet.vue";
import tweets from "./config/tweets.json";
export default {
  name: "TweetGames",
  components: {
    Tweet,
  },
  data: () => {
    return {
      tweets: tweets.tweets,
    };
  },
};
</script>

<style lang="scss">
.content {
  &-games {
    margin-left: 3rem;
    margin-top: -3rem;
    &-tweets {
      columns: 5 250px;
      column-gap: 1.5rem;
    }
  }
}
</style>
